import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Datetime from 'react-datetime';
import { Form, Button, Modal, ButtonGroup } from 'react-bootstrap';
import { equipmentGroupClear } from '../../../actions/equipment-group';
import { createEquipmentGroup, editEquipmentGroup } from '../../../actions/eg-kanban';
import { FormValidator } from '../../../helpers/form-validator';
import { getUTC, toApiDateString, toMoment, getLocalDate } from '../../../helpers/moment-ex';
import { DISPLAY_DATE_FORMAT } from '../../../constants';
import { Aux, Icon, Heading6, Validator, TitleIcon } from '../../widgets';
import "../../../../assets/css/react-datetime.css";
import { uuid } from '../../../helpers/common';

const EGForm = (props) => {

    const getValidationRules = () => {
        const isSelect = (value) => { return (value === null) || (value === ""); }

        return new FormValidator([
            {
                field: 'name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Name is required'
            },
            {
                field: 'startDate',
                method: isSelect,
                validWhen: false,
                message: 'Please select kick-off date'
            }
        ])
    }

    let validator = getValidationRules();
    let submitted = false;

    const initialState = {
        isModeChanged: false,
        farmId: null,
        modeTypeId: null,
        name: "",
        startDate: "",
        validation: validator.valid()
    };

    const [state, setValue] = useState(initialState);

    const setState = (params) => {
        setValue({ ...state, ...params });
    }

    useEffect(() => {
        const farmId = props.farmId;
        setState({ startDate: getUTC().tz(props.timezoneIdentifier), farmId });
        bindValues(props);
    }, []);

    useEffect(() => {
        bindValues(props);
    }, [props.refreshCount]);

    const bindValues = (props) => {
        if (props.isEditMode) {
            submitted = false;
            const r = props.equipmentGroupInfo;

            const params = {
                name: r.name,
                modeTypeId: r.modeTypeId,
                startDate: r.startDate ? toMoment(r.startDate) : getLocalDate(),
                validation: validator.valid()
            }
            setState(params);
        }
        else {
            submitted = false;
            const params = {
                name: "",
                modeTypeId: 1,
                startDate: getUTC().tz(props.timezoneIdentifier),
                validation: validator.valid()
            }
            setState(params);
        }
    }

    const clearAlert = () => {
        props.actions.clear();
    }

    const handleChangeDate = (keyName, event) => {
        setState({ [keyName]: event })
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setState({ [name]: value });
    }

    const handleModeChange = (value) => {
        setState({
            modeTypeId: value,
            isModeChanged: true
        });
    }

    const saveResource = () => {
        const validation = validator.validate(state);
        setState({ validation });
        submitted = true;

        if (validation.isValid) {
            const s = state;

            const egId = props.isEditMode ? props.equipmentGroupInfo.id : uuid();

            const params = {
                id: egId,
                modeTypeId: s.modeTypeId,
                name: s.name,
                startDate: toApiDateString(s.startDate)
            }
            if (props.isEditMode) {
                params.isModeChanged = s.isModeChanged
                props.actions.editEquipmentGroup(egId, params);
            }
            else props.actions.createEquipmentGroup(egId, params);
            disposeForm();
        }
    }

    const disposeForm = () => {
        submitted = false;
        setState({ ...initialState, validation: validator.valid() });
        clearAlert();
        props.onHide();
    }

    const ModeTypeButtonGroup = ({ activeKey, children, onSelect, disabled }) => {
        const childrens = React.Children.map(children, (child) => {
            if (child.props.hasOwnProperty("eventkey")) {
                return React.cloneElement(child, {
                    variant: (parseInt(activeKey) === parseInt(child.props.eventkey)) ? 'primary' : 'default',
                    onClick: () => onSelect(child.props.eventkey),
                    disabled
                });
            }
            return child;
        });

        return <ButtonGroup size="sm" toggle={true} className="mb-2">
            {childrens}
        </ButtonGroup>
    }

    const s = state;
    const validation = submitted ? validator.validate(state) : state.validation;

    return (<Modal show={props.show} onHide={disposeForm} backdrop="static" className="modal-form">
        <Form className="eg-form">
            <Modal.Header closeButton>
                <Modal.Title>
                    <Heading6>
                        <TitleIcon className="fa fa-truck" />
                        {props.isEditMode ? 'Edit Equipment Group' : 'Add Equipment Group'}
                    </Heading6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-0">
                <ModeTypeButtonGroup title="Mode Type" activeKey={s.modeTypeId}
                    onSelect={(e) => handleModeChange(e)} disabled={props.newEgListIds.indexOf(props.egId) >= 0 ? false : props.isEditMode}>
                    <Button eventkey={1}>Vehicle</Button>
                    <Button eventkey={2}>Operator</Button>
                </ModeTypeButtonGroup>
                <Aux>
                    <Form.Group>
                        <Validator validation={validation.name}>
                            <Form.Label htmlFor="txtName">Name<Validator.Mand /></Form.Label>
                            <Form.Control id="txtName" type="text" placeholder="Enter name" className="form-control" autoComplete="off"
                                value={s.name} name="name" onChange={handleChange} />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Aux>
                <Form.Group>
                    <Validator validation={validation.startDate}>
                        <Form.Label htmlFor="dpStartDate">Start Date<Validator.Mand /></Form.Label>
                        <Datetime id="dpStartDate" placeholder="Select start date" name="startDate" closeOnSelect={true}
                            dateFormat={DISPLAY_DATE_FORMAT} onChange={handleChangeDate.bind(this, "startDate")}
                            value={state.startDate} selected={state.startDate} />
                        <Validator.Text />
                    </Validator>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="danger" onClick={disposeForm}><Icon className="fa fa-times"></Icon> Cancel</Button>
                <Button size="sm" variant="primary" onClick={saveResource}><Icon className="fa fa-floppy-o"></Icon> {props.isEditMode ? "Update" : "Add"}</Button>
            </Modal.Footer>
        </Form>
    </Modal >)
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        createEquipmentGroup,
        editEquipmentGroup,
        clear: () => equipmentGroupClear()
    }, dispatch)
});

const mapStateToProps = state => ({
    save: state.equipmentGroup.save,
    farmId: state.egKanban.filters.farmId,
    timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
    newEgListIds: state.egKanban.newEgList.map(e => e.equipment_group_uuid)
});

export default connect(mapStateToProps, mapDispatchToProps)(EGForm);